import { useAsyncRequestComponent } from 'hooks/useAsyncRequestComponent';
import {
  useAsyncRequestSession,
  AsyncRequestHookType,
  AsyncRequestFunctionType,
  AsyncResponseStateType,
} from 'hooks/useAsyncRequestSession';

export enum RequestPersistenceType {
  session = 'session',
  component = 'component',
}

export const useAsyncRequest = <RequestType, ResponseType>(
  requestHook: AsyncRequestHookType<RequestType>,
  persistenceType: RequestPersistenceType = RequestPersistenceType.component
): [
  AsyncRequestFunctionType<RequestType, ResponseType>,
  AsyncResponseStateType<ResponseType>
] => {
  // Create states for both hooks
  const [componentRequest, componentResponse] = useAsyncRequestComponent<
    RequestType,
    ResponseType
  >(requestHook);
  const [sessionRequest, sessionResponse] = useAsyncRequestSession<
    RequestType,
    ResponseType
  >(requestHook);

  // Create a function that will call the correct request function based on the persistence type
  const asyncRequest: AsyncRequestFunctionType<
    RequestType,
    ResponseType
  > = async (request, options) => {
    if (persistenceType === RequestPersistenceType.component) {
      return componentRequest(request, options);
    }
    return sessionRequest(request, options);
  };

  // Create a state that will contain the correct response state based on the persistence type
  const response: AsyncResponseStateType<ResponseType> =
    persistenceType === RequestPersistenceType.component
      ? componentResponse
      : sessionResponse;

  return [asyncRequest, response];
};
